// Member-portal feature flags.
//
// PORTAL_SHOW_DATA_ACQUISITION — when false, the member dashboard hides every
// surface that reveals what the system has captured (ad-count badges, stats
// cards, category distribution, recent-activity feed). The 4 platform shortcut
// buttons stay visible but only as launchers; no counts are shown. Flip back
// to true via VITE_PORTAL_SHOW_DATA_ACQUISITION=true to restore the original
// dashboard for internal preview/dev.
export const PORTAL_SHOW_DATA_ACQUISITION =
  import.meta.env.VITE_PORTAL_SHOW_DATA_ACQUISITION === 'true';
